import Joi from 'joi';

export const ownerLeadFormSchema = Joi.object({
  leadOperation: Joi.string().required().messages({
    'string.empty': 'Lead operation is required',
    'any.required': 'Lead operation is required',
  }),
  community: Joi.object().required().messages({
    'object.base': 'Community is required',
    'object.empty': 'Community is required',
    'any.required': 'Community is required',
  }),
  subCommunity: Joi.object().allow(null),
  saleType: Joi.object().allow(null),
  property: Joi.object().allow(null),
  extraNotes: Joi.string().allow(''),
});
